import { Component, OnInit, Input } from '@angular/core';
import { FormGroupDirective, FormGroup, FormControl, ControlContainer, Validators } from '@angular/forms';
import { LiftDetail } from '../../models/lift-detail.model';
import { LookupDetail } from '../../../core/models/lookup-detail.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lift-form',
  templateUrl: './lift-form.component.html',
  styleUrls: ['./lift-form.component.css'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class LiftFormComponent implements OnInit {
  private _lift: LiftDetail;

  @Input()
  liftEngines: LookupDetail[] = [];

  @Input()
  liftTypes: LookupDetail[] = [];

  @Input()
  liftBoards: LookupDetail[] = [];

  @Input()
  disabled: boolean = false;

  @Input()
  exportedForm: any;

  constructor(
    public parent: FormGroupDirective,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.parent.form.addControl('lift', new FormGroup({
      description: new FormControl(''),
      floorCount: new FormControl('', Validators.required),
      loadCapacity: new FormControl('', Validators.required),
      liftEngine: new FormControl(1, Validators.required),
      liftType: new FormControl(1, Validators.required),
      liftBoard: new FormControl(1, Validators.required)
    }));

    if (this._lift) {
      this.parent.form.patchValue({
        lift: {
          description: this._lift.description,
          floorCount: this._lift.floorCount,
          loadCapacity: this._lift.loadCapacity,
          liftEngine: this._lift.liftEngine.id,
          liftType: this._lift.liftType.id,
          liftBoard: this._lift.liftBoard.id
        }
      });
    }

    if (this.disabled) {     
      this.parent.form.get('lift').disable();
    }
  }

  @Input()
  set lift(lift: LiftDetail) {
    this._lift = lift;
  }

  compare(val1, val2) {
    return val1.id === val2.id;
  }

}
